import React, { Component, Fragment } from 'react'
import styled from 'styled-components'

const Container = styled.div`
	background-color: ${props => props.theme.primary};
	color: ${props => props.theme.primaryText};
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	flex-direction: column;
`

const BackButton = styled.button`
	display: flex;
	align-items: center;
	margin-top: 40px;
	padding: 16px 8px;
	background: transparent;
	color: ${props => props.theme.primaryText};
	border: 1px solid ${props => props.theme.primaryText};
	border-radius: 4px;
	cursor: pointer;
`

class ErrorBoundary extends Component {
	constructor(props) {
		super(props)
		this.state = { hasError: false }
	}

	componentDidCatch(error, info) {
		this.setState({ hasError: true })
	}

	render() {
		return this.state.hasError ? (
			<Container>
				<h3>Oops!!! Isso era para ser uma tela, mas algo deu errado 😬</h3>
				<h3>Por favor contate o nosso suporte</h3>

				<BackButton
					onClick={() => {
						this.setState({ hasError: false })
						history?.back()
					}}
				>
					<p>Voltar para a página anterior</p>
				</BackButton>
			</Container>
		) : (
			<Fragment>{this.props.children}</Fragment>
		)
	}
}

export default ErrorBoundary
